/**
 * Comic font definitions using Google Fonts.
 * These fonts are loaded via a <link> tag in index.html.
 */
export const COMIC_FONTS = [
  { key: "default", label: "Default", family: "inherit" },
  { key: "bangers", label: "Bangers", family: "'Bangers', cursive" },
  { key: "permanent-marker", label: "Permanent Marker", family: "'Permanent Marker', cursive" },
  { key: "patrick-hand", label: "Patrick Hand", family: "'Patrick Hand', cursive" },
  { key: "comic-neue", label: "Comic Neue", family: "'Comic Neue', cursive" },
  { key: "special-elite", label: "Special Elite", family: "'Special Elite', cursive" },
];

export const FONT_SIZE_MIN = 10;
export const FONT_SIZE_MAX = 36;
export const FONT_SIZE_DEFAULT = 14;

/**
 * Google Fonts URL for loading comic fonts.
 * Add this to index.html: <link href="..." rel="stylesheet">
 */
export const GOOGLE_FONTS_URL =
  "https://fonts.googleapis.com/css2?family=Bangers&family=Comic+Neue:ital,wght@0,400;0,700;1,400;1,700&family=Patrick+Hand&family=Permanent+Marker&family=Special+Elite&display=swap";
